module.exports = __webpack_public_path__ + "static/media/Rectangle 85.053a86ad.jpg";